module.exports = __webpack_public_path__ + "img/icon-check-green.8cb94161.svg";